<template>
    <div class="fixed-bottom-wapper">
        <div class="fixed-bottom">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "FixedBottom"
}
</script>

<style scoped>

</style>